export enum UserRole {
  ADMIN = "BUSINESS_ADMIN",
  STAFF = "STAFF",
}

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  countryCode: string;
  diallingCode: string;
  phone: string;
  email: string;
  address: string | null;
  city: string | null;
  zipcode: string | null;
  state: string | null;
  hasVerifiedID: boolean;
  hasVerifiedPhoneNumber: boolean;
  hasVerifiedEmail: boolean;
  hasCards: boolean;
  hasWallets: boolean;
  referralCode: string | null;
  isActive: boolean;
  refreshToken: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  resetToken: string | null;
  resetTokenExpires: string | null;
  role: string;
};

export type BusinessUser = {
  id: string;
  userId: string;
  businessId: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  role: UserRole;
  user: User;
};

export interface GET_USER_API_RESPONSE {
  statusCode: number;
  message: string;
  data: BusinessUser;
}

export interface GET_USERS_API_RESPONSE {
  statusCode: number;
  message: string;
  data: QueryResult<BusinessUser>;
}

export interface InviteUserPayload {
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
}

export interface CREATE_PIN_API_RESPONSE {
  statusCode: number;
  message: string;
  data: string;
}

export interface VALIDATE_PIN_API_RESPONSE {
  statusCode: number;
  error?: string;
  message: string;
  data: ValidatePinResponse;
}

export interface CHANGE_PIN_API_RESPONSE {
  statusCode: number;
  message: string;
}

export interface CreatePinPayload {
  pin: string;
}

export interface ChangePinPayload {
  currentPin: string;
  newPin: string;
}

export interface ValidatePinPayload {
  pin: string;
}

export interface ValidatePinResponse {
  isLocked?: boolean;
  lockoutDurationInMinutes?: number;
  attemptsLeft?: number;
}
